export default __webpack_public_path__ + "static/media/Screenshot crypto1.3df787b0.png";